import PaymentMethodsRootViewModel from 'billing/payment-methods/PaymentMethodsRootViewModel'
import Button from 'components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import * as React from 'react'
import PaymentMethodSelector from '../PaymentMethodSelector'

interface PaymentMethodSelectorModalProps {
  vm: PaymentMethodsRootViewModel
}

/**
 * The PaymentMethodSelectorModal
 */
export default observer(function PaymentMethodSelectorModal({
  vm: { paymentMethodSelectorModal: vm },
}: PaymentMethodSelectorModalProps) {
  const disabled = vm?.selector.disabled || vm?.selector.selectMethod.pending
  return (
    vm && (
      <ModalSheet
        showing={vm.showing}
        onRequestClose={vm.close}
        disableCloseOnOutsideClick={disabled}
        disableCloseOnEsc={disabled}
      >
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              Select Payment Method
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              Select your desired payment method from the list below.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
          <ModalSheetContentBlock>
            <PaymentMethodSelector vm={vm.selector} />
          </ModalSheetContentBlock>
        </ModalSheetContent>
        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button disabled={disabled} onClick={vm.close}>
              Close
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </ModalSheet>
    )
  )
})
